import Vue from 'vue';

export default Vue.extend({
	data () {
		return {
			tabs_progress: null,
		};
	},
});